var map = {
	"./background.jpg": "AS41",
	"./bg2.jpg": "/LkK",
	"./blog.png": "v+3t",
	"./contact.png": "550A",
	"./lab.png": "PKOI",
	"./logo.png": "7Otq",
	"./pic.jpg": "/9BQ",
	"./pic2.jpg": "4OB5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1